/* eslint-disable import/prefer-default-export */

export const propertyToRawProperty = {
  logo: 'logo_source_urls',
};

export const toRawProperty = property =>
  propertyToRawProperty[property] || property;
